import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	messageStatusIcon: {
		width: 16,
		height: 16
	},
	messageFooter: {
		gap: 6
	},
	messageTimeText: {
		fontSize: 10
	},
	messageSenderName: {
		fontWeight: "bold",
		color: colors.gray[950]
	},
	metaFreeEntryPointWindowIcon: {
		width: 15,
		height: 15,
		color: colors.purple[700],
		display: "block"
	}
})

export default useStyles
